import { Component } from 'react'
import { Box, FormSchemaForm, Page, Icons } from 'stylewhere/components'
import { FormSchema, FormSchemaData, SimpleReadingListOperationConfig } from 'stylewhere/shared'
import { SimpleReadingListExtensions } from 'stylewhere/extensions'
import { isModalError } from 'stylewhere/utils'
import { T, __ } from 'stylewhere/i18n'

export interface Props {
  operation: SimpleReadingListOperationConfig
  onCreate: (formData: FormSchemaData, operation: SimpleReadingListOperationConfig, schema) => void
}

interface State {
  schema?: FormSchema
  isModal: boolean
}

export class SimpleReadingStartInput extends Component<Props, State> {
  state: State = {
    isModal: false
  }

  componentDidMount() {
    const { operation } = this.props

    const schema = SimpleReadingListExtensions.formSchema(operation)

    this.setState({
      schema,
      isModal: isModalError(operation)
    })
  }

  render() {
    const { operation, onCreate } = this.props
    const { schema } = this.state
    return (
      <Page.Content notBoxed>
        <Box flex>
          <Box flex center>
            {schema ? (
              <FormSchemaForm
                schema={schema}
                submitText={__(T.misc.next)}
                onSubmit={(form: any) => {
                  onCreate(form, operation, schema)
                }}
                formContext="start"
                operation={operation}
              />
            ) : (
              <Icons.Loader1 width={100} />
            )}
          </Box>
        </Box>
      </Page.Content>
    )
  }
}
